<template>
  <div>
    <h2>Export Notifications</h2>
    <div class="form-group">
      <div class="col-md-12 m-b-lg" >
        <button class="btn btn-sm btn-success col-md-2"  @click="exportNotifications">
          <span><i class="fa fa-cloud-download"></i>&nbsp;Export Notifications</span>
        </button>
      </div>
    </div>
    <h2>Import Notifications</h2>
    <div class="form-group">
      <div class="col-md-12 p-h-xs" >
      <input type="file" @change="(output) => { setImportedFile(output) }">
        <br/>
        <ladda-button
          class="btn btn-sm btn-success col-md-2 m-b-lg"
          type="submit"
          :click="() => { return handleImportCallback('import-notifications', 0) }">
          Import & Keep Existing
        </ladda-button>
        <ladda-button
          class="btn btn-sm btn-danger col-md-2 m-b-lg m-l-md"
          type="submit"
          :click="confirmNotificationImport">
          Import & Override
        </ladda-button>
      </div>
    </div>

  </div>
</template>

<script>
import { http, notify, alert } from 'utils'

export default {
  props: [
  ],
  data () {
    return {
      uploading: false,
      activate_notification: false,
      imported_file: null
    }
  },

  methods: {
    exportNotifications (e) {
      e.preventDefault()
      this.$http.get('export-notifications')
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([JSON.stringify(response.data)], {type: 'application/json'}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `notification-import.json`)
          document.body.appendChild(link)
          link.click()
        })
        .catch(hr => {
          notify.error('There are issues with your export. Please review and try again')
        })
    },
    setImportedFile ({ target: { files } }) {
      if (files.length !== 0) {
        for (let i = 0; i < files.length; i++) {
          if (files[i].size >= 15000000) {
            notify.error('Maximum file size is 15MB. Unable to upload file: ' + files[i].name)
          } else {
            this.imported_file = files[i]
          }
        }
      }
    },
    handleImportCallback (action, override) {
      if (this.imported_file === null) {
        notify.error('Please upload a file')
        return Promise.reject(new Error())
      }
      let payload = new FormData()
      payload.append('file', this.imported_file)
      payload.append('activate_notification', this.activate_notification)
      payload.append('override', override)

      return this.uploadFile(payload, action).then(response => {
      }).catch((error) => {
        if (error.response && error.response.data.errors && error.response.data.errors.text && error.response.data.errors.text[0]) {
          notify.error(error.response.data.errors.text[0])
        } else {
          notify.error('Something went wrong uploading your file. Please try again.')
        }
      })
    },
    uploadFile (payload, action) {
      return http.post(action, payload, {
        headers: {'Content-Type': 'multipart/form-data'},
        maxContentLength: 15000000
      })
        .then((response) => {
          return response
        })
    },
    confirmNotificationImport () {
      const confirmAlertOptions = {
        title: 'Import Notifications',
        text: 'Are you sure you want override existing notifications ? (You may export existing notifications first)'
      }

      return alert.confirm(confirmAlertOptions)
        .then(() => {
          this.handleImportCallback('import-notifications', 1)
        })
        .catch(() => {
          //
        })
    }
  }
}
</script>
